import { BdmBatchFileStatus } from '../constants/common.constant';

export const canSubmitBdmBatchFilePolicy = (status: string) => {
  return status === BdmBatchFileStatus.READY_TO_SUBMIT;
};

export const canViewEndedBdmBatchFilePolicy = (status: string) => {
  return [BdmBatchFileStatus.SUBMITTED, BdmBatchFileStatus.CANCEL].includes(status as BdmBatchFileStatus);
};
